import { render, staticRenderFns } from "./ButtonsHome.vue?vue&type=template&id=7e11d2fa&"
import script from "./ButtonsHome.vue?vue&type=script&lang=js&"
export * from "./ButtonsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports